'use client'

import { getLocalTimeZone } from '@internationalized/date'
import type { FC } from 'react'
import { getLocalizedDate } from 'lib/getLocalizedDate'
import { toCalendarDateTime } from '@internationalized/date'
import { Label } from 'ui/label'
import { DateTimePicker } from 'ui/date-time-picker/date-time-picker'
import type { DateValue } from 'react-aria'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

export const datetimeFieldConfig = {
    getInitialValue: (field: TFormField) =>
        field.defaultValue
            ? new Date(field.defaultValue as string).toISOString()
            : new Date().toISOString()
} satisfies Partial<import('./types').FieldTypeConfig>

const DatetimeField: FC<FieldRendererProps> = ({ field, value, error, onChange }) => {
    const resolvedValue = value
        ? toCalendarDateTime(getLocalizedDate(new Date(value as string)))
        : field.defaultValue
          ? toCalendarDateTime(getLocalizedDate(new Date(field.defaultValue as string)))
          : toCalendarDateTime(getLocalizedDate(new Date()))

    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <Label htmlFor={field.name}>{field.label}</Label>
            <DateTimePicker
                label={field.label as string}
                value={resolvedValue}
                onChange={(date: DateValue | null) => {
                    if (date) {
                        const localDate = date.toDate(getLocalTimeZone())
                        onChange(field.name, localDate.toISOString(), field)
                    }
                }}
                granularity={field.granularity || 'minute'}
                isDisabled={!!field?.disabled}
            />
        </FieldWrapper>
    )
}

export default DatetimeField
